var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('static-tabs-wallet',{attrs:{"active":"contacts"}}),_vm._v(" "),_c('agency-contacts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }